import React, { useState } from 'react';
import { Receipt, Money, Bank } from 'phosphor-react';
import { useFetch } from '_api';
import { formatVND, formatDate } from '_helpers';
import { PageHeader, Bezel, Table, StatCard, StatusPill, Tag, MonthYearPicker, MotionReveal } from '_ui';
import { InvoiceDetail } from '_components/InvoiceDetail';

const now = new Date();

function itemsSummary(items = []) {
    if (!items.length) return '—';
    const first = `${items[0].name} ×${items[0].quantity}`;
    return items.length > 1 ? `${first} +${items.length - 1}` : first;
}

export function GiaoDichCuaToi() {
    const [period, setPeriod] = useState({ month: now.getMonth() + 1, year: now.getFullYear() });
    const [selected, setSelected] = useState(null);
    const { data, loading } = useFetch(`/api/transactions/me?month=${period.month}&year=${period.year}`);
    const rows = data || [];

    const paid = rows.filter(r => r.status === 'paid');
    const paidTotal = paid.reduce((s, r) => s + r.totalPrice, 0);
    const pendingTotal = rows.filter(r => r.status === 'pending').reduce((s, r) => s + r.totalPrice, 0);

    const columns = [
        { key: 'createdAt', header: 'Ngày', render: r => <span className="tnum text-espresso-soft">{formatDate(r.createdAt)}</span> },
        { key: 'customer', header: 'Khách', render: r => r.customerName || <span className="text-espresso-soft/50">—</span> },
        { key: 'items', header: 'Dịch vụ', render: r => <span className="text-espresso-soft">{itemsSummary(r.items)}</span> },
        { key: 'method', header: 'Hình thức', render: r => (
            <Tag tone="neutral"><span className="inline-flex items-center gap-1.5">{r.paymentMethod === 'cash' ? <Money size={13} /> : <Bank size={13} />}{r.paymentMethod === 'cash' ? 'Tiền mặt' : 'Chuyển khoản'}</span></Tag>
        ) },
        { key: 'total', header: 'Tiền', align: 'right', render: r => <span className="tnum font-medium">{formatVND(r.totalPrice)}</span> },
        { key: 'commission', header: 'Hoa hồng', align: 'right', render: r => <span className="tnum text-sage-deep">{formatVND(r.totalCommission)}</span> },
        { key: 'status', header: 'Trạng thái', align: 'right', render: r => <StatusPill status={r.status} pendingLabel="Chờ thu" paidLabel="Đã thu" /> },
    ];

    return (
        <div className="space-y-10">
            <PageHeader
                eyebrow="Nhân viên"
                title="Giao dịch của tôi"
                description="Các hoá đơn bạn đã tạo trong tháng."
                actions={<MonthYearPicker value={period} onChange={setPeriod} />}
            />

            <div className="grid gap-5 sm:grid-cols-3">
                <MotionReveal><StatCard label="Số hoá đơn" value={rows.length} icon={Receipt} /></MotionReveal>
                <MotionReveal delay={0.05}><StatCard label="Đã thu" value={formatVND(paidTotal)} accent="sage" /></MotionReveal>
                <MotionReveal delay={0.1}><StatCard label="Chờ thu" value={formatVND(pendingTotal)} accent="brass" /></MotionReveal>
            </div>

            <Bezel className="overflow-hidden">
                <Table columns={columns} rows={rows} loading={loading} onRowClick={setSelected} empty="Tháng này bạn chưa có hoá đơn nào." />
            </Bezel>

            <InvoiceDetail invoice={selected} onClose={() => setSelected(null)} />
        </div>
    );
}
